import Business from './Business';

export default Business;
